import { action, observable } from 'mobx';
import { useStaticRendering } from 'mobx-react';

const isServer = !process.browser;
useStaticRendering(isServer);

class AlertStore {
  @observable error = '';
  @observable success = '';
  @action setError(error) {
    this.error = error;
  }
  @action setSuccess(success) {
    this.success = success;
  }
}

let alertStore = null;

export default function initializeAlertStore(initialData) {
  if (isServer) {
    return new AlertStore(isServer, initialData);
  }

  if (alertStore === null) {
    alertStore = new AlertStore(isServer, initialData);
  }
  return alertStore;
}
